import ErrorBox from '@components/common/ErrorBox';
import DwFormField from '@ui/formfield/DwFormField';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import classNames from 'classnames';
import createDecorator from 'final-form-focus';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
const focusOnError = createDecorator(); // must be outside the component
const WishlistShare = (props) => {
    const { show, setShow, wishlist, formdef } = props;
    const { t } = useTranslation();
    const shareItem = !!props.product;
    const [showShareByEmail, setShowShareByEmail] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [errors, setErrors] = useState([]);
    const [copyStatus, setCopyStatus] = useState(false);
    // reset copyStatus after 800ms
    useEffect(() => {
        if (copyStatus) {
            setTimeout(() => {
                setCopyStatus(false);
            }, 800);
        }
    }, [copyStatus]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'wishlist-share');
    };
    const onSubmit = async (values) => {
        var _a, _b;
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        if (wishlist && props.product && props.product.mbm) {
            wishlist.items.forEach((item) => {
                var _a;
                if (item.id === props.product.id && item.mbm.recipeId === ((_a = props.product.mbm) === null || _a === void 0 ? void 0 : _a.recipeId)) {
                    values.listId = wishlist.UUID;
                }
            });
        }
        if (shareItem) {
            return api
                .ShareSingleProductWishlist(props.product.id, values.email, values.message, values.listId || '', ((_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.mbm) === null || _b === void 0 ? void 0 : _b.recipeId) || '')
                .then((data) => {
                if (data.success) {
                    setSubmitSuccess(true);
                    setShowShareByEmail(false);
                }
                else {
                    setErrors([data.errorMsg]);
                }
            })
                .catch((e) => setErrors([e]));
        }
        else {
            values.listId = getListId();
            return api
                .shareWishlist(values, formdef)
                .then((data) => {
                if (data.success) {
                    setSubmitSuccess(true);
                    setShowShareByEmail(false);
                }
                else {
                    setErrors(data.error || [t('errorpage.text')]);
                }
            })
                .catch((e) => setErrors([e]));
        }
    };
    const copyWishlist = async () => {
        if (shareItem) {
            navigator.clipboard.writeText(location.origin + props.product.productUrl);
            setCopyStatus(true);
        }
        else {
            navigator.clipboard.writeText(wishlist === null || wishlist === void 0 ? void 0 : wishlist.shareWishlistsUrl);
            setCopyStatus(true);
            //   return api
            //     .GeneratePublicWishlist(wishlists.map((list) => list.UUID)[0])
            //     .then((data) => {
            //       if (data) {
            //         // navigator.clipboard.writeText(data.urlRedirect);
            //         copyToClipboardWithIosSupport(data.urlRedirect);
            //         setCopyStatus(true);
            //       } else {
            //         setErrors([data.errorMsg]); // TODO check errors
            //       }
            //     })
            //     .catch((e) => setErrors([e]));
        }
    };
    const getListId = () => {
        return wishlist.UUID;
    };
    const resetModal = () => {
        setShow(false);
        setSubmitSuccess(false);
        setShowShareByEmail(false);
        setErrors([]);
    };
    return (React.createElement(ModalDialog, { overlayClassName: 'mobile-visible', hideHeader: true, isOpen: show, onRequestClose: () => resetModal(), className: "wishlist-share modal--fixed-small" },
        React.createElement("div", { className: "wishlist-share__modal-header" },
            showShareByEmail && (React.createElement("button", { type: "button", className: "button wishlist-share__btn--email-step-back", onClick: () => {
                    setShowShareByEmail(false);
                } },
                React.createElement("i", { className: "icon--chevron-left-big" }))),
            React.createElement("h2", { className: "wishlist-share__modal-title primary-m" }, t(shareItem ? 'wishlist.shareitem' : 'wishlist.shareyour'))),
        submitSuccess ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "newsletter-modal__description" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: t('wishlist.sharesent') } }),
                React.createElement("button", { onClick: () => setShow(false), className: "button button--primary" }, t('newslettermodal.backtowishlist'))))) : (React.createElement(React.Fragment, null,
            !showShareByEmail && (
            /* TODO add paragraph translation and copy wishlist button */
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "wishlist-share__description" },
                    React.createElement("p", { className: "primary-s" }, t(shareItem ? 'wishlist.shareitemdescription' : 'wishlist.sharedescription'))),
                React.createElement("button", { type: "button", className: "button button--secondary wishlist-share__mail-share-btn", onClick: () => {
                        setShowShareByEmail(true);
                        analytics.wishlistInteractionShare('email');
                    }, "aria-expanded": showShareByEmail ? 'true' : 'false', "aria-haspopup": "dialog" },
                    React.createElement("i", { className: "icon--mail" }),
                    t('wishlist.sharebyemail')),
                React.createElement("button", { type: "button", className: classNames('button', copyStatus ? 'button--primary' : 'button--secondary', 'wishlist-share__copy-btn'), onClick: () => {
                        copyWishlist();
                        analytics.wishlistInteractionShare('link');
                    } }, copyStatus ? t('label.copied') : t('label.copy')))),
            showShareByEmail && (React.createElement(Form, { decorators: [focusOnError], onSubmit: onSubmit, validate: validate, mutators: { global: formutils.globalMutator }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "ReserveForm" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(DwFormField, { def: formdef, name: "email", autoFocus: true }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(DwFormField, { def: formdef, name: "message", type: "textarea" }))),
                            React.createElement(DwFormField, { def: formdef, name: "listId", type: "hidden", hiddenLabel: true })),
                        React.createElement("div", { className: "product-reserve__detail__form__submit" },
                            React.createElement("button", { type: "submit", disabled: submitting, className: "button button--primary" }, t('button.send'))),
                        React.createElement(ErrorBox, { errors: errors })))) }))))));
};
export default WishlistShare;
